ThirdPartyAdsView =
  hideDealTileIfAdBlocked: ->
    # check ad container if it is blocked
    $adBlockBait = $(".ad_container")
    if $adBlockBait.is(":visible") is false
      $(ad).closest(".deal-card").hide() for ad in $('.deal-ad-card')

module.exports = ThirdPartyAdsView
